import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { saveAddress } from "../../../Redux/Actions/userActions";
import { fetchLocation } from "../../../Request/LoginRequests";
import { editAddress } from "../../../Request/UserRequests";
import mapPin from "../../../img/location-icon1.png";
const PIN = 124507;
export default function ChangeAddress() {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user?.info);
  const userAddress = useSelector((state) => state.user?.address);

  const [areas, setAreas] = useState([]);
  const [select, setSel] = useState(null);

  const primaryAddress = useMemo(() => {
    return userAddress?.filter((address) => {
      if (address?.primary) {
        return true;
      }
    })[0];
  }, [userAddress]);

  const getAreas = useCallback(() => {
    fetchLocation(PIN).then((data) => setAreas(data));
  }, [fetchLocation, PIN]);

  useEffect(() => {
    getAreas();
  }, [getAreas]);

  const selectHandler = (index) => {
    let current = {
      ...primaryAddress,
      area: areas[index]?.placeName,
    };
    const id = current?.addressId;

    editAddress(id, user?.userHash, current).then((res) => {
      const newCopy = JSON.parse(JSON.stringify(userAddress));

      const index = newCopy.findIndex((el) => {
        if (el.addressId == id) {
          return true;
        }
      });
      newCopy[index] = {
        ...current,
        addressId: res.addressId,
        lat: areas[index]?.latitude,
        long: areas[index]?.longitude,
      };
      dispatch(saveAddress(newCopy));
    });
  };

  return (
    <>
      {/* span */}
      <span
        id="spanSelectArea"
        data-bs-target="#selectArea"
        data-bs-toggle="offcanvas"
      ></span>

      {/* Select Area Popup */}
      <div
        className="offcanvas h-auto bg-tr changeAdd-offset"
        tabIndex="-1"
        id="selectArea"
      >
        <div
          className="text-light d-flex align-items-center offset-title"
          style={{
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            fontSize: "12px",
            padding: "4px 8px",
            borderRadius: "24px",
            background: "linear-gradient(180deg, #A93A4E 0%, #B94A57 100%)",
            marginRight: "-8px",
            alignSelf: "end",
          }}
          data-bs-dismiss="offcanvas"
        >
          <img
            src={mapPin}
            alt=""
            width={16}
            className="d-block"
            style={{ marginRight: "4px" }}
          />
          {primaryAddress ? (
            <>
              {primaryAddress?.area}
              {primaryAddress?.city !== "NA" ? (
                <>, {primaryAddress.city}</>
              ) : (
                ""
              )}
            </>
          ) : (
            ". . . "
          )}
          <i className="bi bi-chevron-down" style={{ marginLeft: "4px" }}></i>
        </div>
        {/* Body */}
        <div className="offcanvas-body bg-white">
          {/* Areas */}
          {areas.map((key, i) => (
            <div
              key={i}
              className={"selectArea" + (i === select ? " checked" : "")}
              data-bs-dismiss="offcanvas"
              onClick={() => {
                setSel(i);
                selectHandler(i);
              }}
            >
              {key.placeName}, {key.adminName3}
            </div>
          ))}
        </div>
        <div className="offcanvas-footer">
          <div
            className="bi bi-x-circle mx-auto"
            id="closeSelectArea"
            data-bs-dismiss="offcanvas"
          ></div>
        </div>
      </div>
    </>
  );
}
